import { Link, useLoaderData } from "react-router-dom";
import "./Services.scss";
import axios from "axios";
import Loader from "../../Utils/Loader";


export const fetchServiceLoader = async ({ params }) => {
  try {
    const api = process.env.REACT_APP_API_URL;
    const res = await axios.get(
      `${api}/services/${encodeURIComponent(params.title)}`,
      { withCredentials: true }
    );

    if (res.status !== 200) {
      return;
    }

    return res.data;
  } catch (error) {
    return []
  }
};

export default function Services() {
  const loaderData = useLoaderData();
  if (!loaderData || loaderData.length <= 0) {
    return <Loader height="60vh" />;
  }

  const section = loaderData[0];
  const paragraphs = section.content.split(/\n\s*\n/);

  return (
    <div className="value-addition-container">
      <div
      >
        <h2>{section.title.toUpperCase()}</h2>
      </div>
      <div className="value-addition">
        <div>
          <span>
            <Link to="/">
              <i className="ri-home-9-line"></i>Home
            </Link>
          </span>
          <span>›</span>
          <span>{section.title}</span>
        </div>

        <div>
          <h1>{section.title.toUpperCase()}</h1>
          <p>{section.subtitle}</p>
        </div>

        <div>
          {paragraphs.map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
